<div class="layout-topbar">
    <a class="layout-topbar-logo">
        <img src="./assets/micada_logo.png" alt="logo" width="90vw" height="50vh">
        <div class="hidden md:block" [ngStyle]="{'color': '#990000', 'font-size':'13px'}" ><b>MICADA Portal Version 2.0 <br><div class="flex justify-content-center">(FY: 2022-23)</div></b></div>
    </a>
    <div class="justify-content-center">
        <p-dropdown [(ngModel)]="selectedLang"[options]='[{name: "English", code:"en"}, {name: "Hindi",code:"hd"}]' optionLabel="name"
            (onChange)="languageChange($event)">
        </p-dropdown>
    </div>
    <div class="justify-content-center mx-2">
        <p-dropdown [(ngModel)]="selectedYear"[options]='financialYears' optionLabel="name"
                (onChange)="yearChange($event)">
        </p-dropdown>
    </div>
    <a class="p-link layout-menu-button layout-topbar-button" (click)="appMain.toggleMenu($event)">
        <i class="pi pi-bars"></i>
    </a>

    <a class="p-link layout-topbar-menu-button layout-topbar-button" (click)="appMain.toggleTopMenu($event)">
        <i class="pi pi-ellipsis-v"></i>
    </a>

    <!-- <div class="field-checkbox justify-content-center">
        <p-dropdown [options]='[{name: "English"}, {name: "Hindi"}]' optionLabel="name"
            (onChange)="wrongNotification($event)">
        </p-dropdown>
    </div> -->
    <div class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active':appMain.topMenuActive}">
        <h5 class="mt-2">{{userName}}</h5>
        <a class="p-link layout-topbar-button"  (click)="menu.toggle($event)">
            <i class="pi pi-user"></i>
            <span (click)="logOut()">{{'LOGOUT'| translate}}</span>
        </a>
        <div style="position:absolute !important; margin-left:-35px !important;" >
        <p-menu  #menu [popup]="true" [model]="items" styleClass="prime-slider-override"></p-menu>
        </div>
    </div>
</div>
